import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayFieldPipe } from './display-field.pipe';
import { DisplayAndCheckImagePipe } from './display-and-check-image.pipe';
import { DateConvertPipe } from './date-convert.pipe';
import { DisplaySymbolForZeroPoPipe } from './display-symbol-for-zero-po.pipe';




@NgModule({
  declarations: [
    DisplayFieldPipe,
    DisplayAndCheckImagePipe,
    DateConvertPipe,
    DisplaySymbolForZeroPoPipe
    ],
  imports: [
    CommonModule
  ],
  exports:[
    DisplayFieldPipe,
    DisplayAndCheckImagePipe,
    DateConvertPipe,
    DisplaySymbolForZeroPoPipe
  ]
})
export class DisplayPipesModule { }
